import { API } from '../config/config';

const StoreCreditService = {
  create: (storeId, data) => createStoreCredit(storeId, data),
  getAll: (storeId, status, nameSale, page, limit) => getStoreCredits(storeId, status, nameSale, page, limit),
  getByCode: (storeId, code) => getStoreCreditByCode(storeId, code),
  apply: (storeId, code, saleId, amount) => applyStoreCredit(storeId, code, saleId, amount),
  cancel: (storeId, id) => cancelStoreCredit(storeId, id),
};

const createStoreCredit = async (storeId, data) => {
  try {
    const response = await API.post(`/stores/${storeId}/store-credits`, data);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

// Returns the paginated envelope { items, total, page, page_size, total_pages }.
const getStoreCredits = async (storeId, status, nameSale, page, limit) => {
  try {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (nameSale) params.set('name_sale', nameSale);
    if (page) params.set('page', page);
    if (limit) params.set('limit', limit);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await API.get(`/stores/${storeId}/store-credits${query}`);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

const getStoreCreditByCode = async (storeId, code) => {
  try {
    const response = await API.get(`/stores/${storeId}/store-credits/${encodeURIComponent(code)}`);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

const applyStoreCredit = async (storeId, code, saleId, amount) => {
  try {
    const body = { sale_id: saleId };
    if (amount) body.amount = amount;
    const response = await API.post(`/stores/${storeId}/store-credits/${encodeURIComponent(code)}/apply`, body);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

const cancelStoreCredit = async (storeId, id) => {
  try {
    const response = await API.post(`/stores/${storeId}/store-credits/${id}/cancel`);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

export default StoreCreditService;
